/**
 * Lets the mode switch finish its thumb travel before navigating.
 *
 * Both halves stay real links. This only defers the navigation by the length of the transition, and
 * every guard below exists so the browser's own behaviour wins wherever it should: middle-click,
 * modified click, an already-current link, reduced motion, or no JavaScript at all.
 *
 * Delegated from the document rather than bound per element. The previous version looped over the
 * switches present at parse time and marked each ready, so a switch re-rendered by the theme editor
 * came back inert — and the ready flag made re-running the module a no-op. One listener on the
 * document covers every switch, including ones that do not exist yet.
 */

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const DELAY_MS = 360;

document.addEventListener('click', (event) => {
  const link = event.target.closest?.('[data-timecard-mode]');
  if (!link) return;

  const switcher = link.closest('[data-timecard-mode-switch]');
  if (!switcher) return;

  if (
    event.defaultPrevented ||
    event.button !== 0 ||
    event.metaKey ||
    event.ctrlKey ||
    event.shiftKey ||
    event.altKey ||
    switcher.dataset.pendingMode ||
    link.getAttribute('aria-current') === 'page' ||
    reduceMotion.matches
  ) {
    return;
  }

  event.preventDefault();
  switcher.dataset.pendingMode = link.dataset.timecardMode;

  window.setTimeout(() => {
    window.location.assign(link.href);
  }, DELAY_MS);
});

/**
 * Clears the pending flag when a page is shown, including a back/forward restore.
 *
 * Without this, bfcache returns the page exactly as it left — mid-transition, with `pendingMode`
 * still set. The thumb would sit frozen on the half the visitor navigated away from, and the guard
 * above would refuse every further click because a navigation still looks pending.
 */
window.addEventListener('pageshow', () => {
  for (const switcher of document.querySelectorAll('[data-timecard-mode-switch]')) {
    delete switcher.dataset.pendingMode;
  }
});
